<template>
  <div id="app">
    <router-view class="page" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    $route(to, from) {
    }
  },
  created() {
  },
  methods: {}
};
</script>

<style lang="less">
  #app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
    font-family: 'siyuan';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: @colorFont;
    font-size: @fontSizeH3;
  }

  .mecity {
    font-family: 'mecity';
  }
</style>
